import { RootState } from "@/store/types";
import { GetterTree } from "vuex";
import { StatisticState } from "./types";

export const getters: GetterTree<StatisticState, RootState> = {
  whatsappStatisticDetail: (state) => state.whatsappStatisticDetail,
  whatsappStatisticGroup: (state) => state.whatsappStatisticGroup,
  whatsappGroupBy: (state) => state.whatsappGroupings.whatsappGroup,
  whatsappGroupByOptionally: state => state.whatsappGroupings.whatsappGroupOptionally,
};